import React, { useState } from 'react';
import {
    Row, Col, Modal, ModalBody, ModalFooter, Button
} from 'reactstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { api2 } from '~/services/api';

export default function PlanSuspensionModal({ open, toggle, suspension, loadData }) {
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event, errors, values) => {
        if (errors.length > 0) return;

        setLoading(true);
        try {
            if (suspension && suspension.id) {
                await api2.put(`plan-suspensions/${suspension.id}`, values);
                toast.success('Suspensão atualizada com sucesso');
            } else {
                await api2.post('plan-suspensions', values);
                toast.success('Suspensão criada com sucesso');
            }
            toggle();
            loadData();
        } catch (error) {
            console.error(error);
            toast.error('Erro ao salvar suspensão');
        } finally {
            setLoading(false);
        }
    };

    const defaultModel = suspension ? {
        ...suspension,
        user_email: suspension.user_email || suspension.user?.email || ''
    } : {};

    return (
        <Modal isOpen={open} toggle={toggle} size="lg">
            <AvForm onSubmit={handleSubmit} model={defaultModel}>
                <ModalBody>
                    <Row>
                        <Col md={12}>
                            <h4 className="mb-4">{suspension ? 'Editar Suspensão' : 'Nova Suspensão'}</h4>

                            <Row>
                                <Col md={6}>
                                    <AvField
                                        name="user_email"
                                        label="Email do Usuário"
                                        type="email"
                                        required
                                        errorMessage="Email do usuário é obrigatório"
                                        disabled={!!(suspension && suspension.id)}
                                    />
                                </Col>
                                <Col md={6}>
                                    <AvField
                                        name="status"
                                        label="Status"
                                        type="select"
                                        required
                                    >
                                        <option value="in_progress">EM PROGRESSO</option>
                                        <option value="finished">FINALIZADO</option>
                                    </AvField>
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <AvField
                                        name="start_at"
                                        label="Início"
                                        type="date"
                                        required
                                        errorMessage="Data de início é obrigatória"
                                        value={suspension ? moment(suspension.start_at).format('YYYY-MM-DD') : ''}
                                    />
                                </Col>
                                <Col md={6}>
                                    <AvField
                                        name="end_at"
                                        label="Fim"
                                        type="date"
                                        required
                                        errorMessage="Data de fim é obrigatória"
                                        value={suspension ? moment(suspension.end_at).format('YYYY-MM-DD') : ''}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button color="primary" type="submit" disabled={loading}>
                        {loading ? 'Salvando...' : 'Salvar'}
                    </Button>
                </ModalFooter>
            </AvForm >
        </Modal >
    );
}
